function Shipping() {
    return(
        <div className="store-features">
        <div className="container">
            {/* <div className="row store-info">
                <div className="col-12 col-sm-6 col-md-10 col-lg-10">
                    <input type="text" placeholder="email id "></input>
                </div>
                <div className="col-12 col-sm-6 col-md-2 col-lg-2">
                  <button className="btn btn-button btn-primary" style={{ padding:"8px", marginTop:"0", borderRadius:"2px", color: "white !important" }}> Subscribe </button>
                </div>
            </div> */}
        </div>
    </div>
  )
}
export default Shipping;